import { StyleSheet, Text, View, TouchableOpacity } from "react-native";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

const TopCardsBar = () => {
  const [dateNow, setDateNow] = useState(new Date());
  const user = useAppSelector((s) => s.auth.subUser);
  const naviagation = useNavigation();
  useEffect(() => {
    const timer = setInterval(() => {
      setDateNow(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const status =
    user &&
    user.card?.isic_data?.status &&
    user.card?.isic_data?.status !== "Pending"
      ? new Date(user.card?.expiry) > dateNow
        ? "VALID"
        : "EXPIRED"
      : "PENDING";
  return (
    <View
      style={[
        styles.root,
        { backgroundColor: status === "VALID" ? "#353e42" : "#FF0000" },
      ]}
    >
      <TouchableOpacity onPress={() => naviagation.goBack()}>
        <Ionicons
          name="chevron-back"
          size={32}
          style={styles.arrowIcon}
          color="#fff"
        />
      </TouchableOpacity>
      {status === "VALID" && <View style={styles.successCircle} />}
      <Text style={styles.status}>{status}</Text>
      <View style={styles.timeContainer}>
        <Text style={styles.time}>
          {`${(dateNow.getDate() < 10 ? "0" : "") + dateNow.getDate()}-${
            (dateNow.getMonth() + 1 < 10 ? "0" : "") + (dateNow.getMonth() + 1)
          }-${dateNow.getFullYear()}`}
        </Text>
        <Text style={styles.time}>
          {`${(dateNow.getHours() < 10 ? "0" : "") + dateNow.getHours()}:${
            (dateNow.getMinutes() < 10 ? "0" : "") + dateNow.getMinutes()
          }:${(dateNow.getSeconds() < 10 ? "0" : "") + dateNow.getSeconds()}`}
        </Text>
      </View>
    </View>
  );
};

export default TopCardsBar;

const styles = StyleSheet.create({
  root: {
    flexDirection: "row",
    height: 40,
    marginBottom: 5,
    width: "100%",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
  },
  arrowIcon: {
    marginHorizontal: 5,
  },
  successCircle: {
    width: 15,
    height: 15,
    borderRadius: 7.5,
    backgroundColor: "#22bb44",
    marginRight: 20,
  },
  status: {
    fontSize: 17,
    color: "#fff",
    letterSpacing: 1.3,
    marginRight: 20,
  },
  timeContainer: {
    marginLeft: "auto",
    flexDirection: "row",
  },
  time: {
    fontSize: 14,
    letterSpacing: 0.5,
    color: "#fff",
    marginRight: 10,
  },
});
